module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('strong', [_c('em', [_vm._v("“Wasn’t it the Luxe group who blew the whistle on them?” Lon asked.")])])])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Yep. Their leader led the police to the murder weapon. When my parents’ fingerprints were found on it, support from the occult community began to wane. It didn’t look good. Then the warrant for my parents’ arrest was issued. At that point, they were facing serious charges from the law and even bigger threats from Luxe. There was no way out—they had to run.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me too,” I agreed, remembering the panic and fear … the sudden loss of my family. “I don’t know how Luxe got their fingerprints, but it was rigged evidence. It was a demon, not a knife, that did the dirty work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The albino demon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But they didn’t summon it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. We think it was either someone from the Luxe group who was trying to sabotage our order, or a rogue magician trying to take over all the orders. If I can find the demon, I can force it to tell me who did it. My parents can be exonerated, the person who summoned the demon and killed three people can go to jail, and the Luxe Order will leave me the hell alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You need me to find it fast because the police will be looking for your parents?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that doesn’t help matters, but it’s more because the Luxe Order has given my organization a mandate to turn over my parents—or me—in two weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His eyebrows shot up. “What would they do if you turned yourself in to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kill me,” I said very seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Turn the page for rave reviews of "), _c('em', [_vm._v("Kindling the Moon")]), _vm._v(". …")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0